import React from 'react';
import { CheckIcon, FuelIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { Countdown } from './ui/Countdown';
import { checkoutUrl, price, priceBefore, productShortName, totalBonuses, totalVolumes } from '../data/offer';
const assurances = ['Garantía de 7 días', 'Pago seguro', 'Acceso inmediato', 'Material listo para usar desde hoy'];
export function FinalCta() {
  return <section className="bg-emerald-950 py-16 sm:py-20" aria-labelledby="final-title" data-id="element-77" data-mp="1jcd4g9xq3yc0">
      <div className="mx-auto max-w-3xl px-4 text-center" data-id="element-78" data-mp="1eek0lnjw7gew">
        <p className="inline-flex items-center gap-2 text-xs font-extrabold uppercase tracking-[.16em] text-amber-300" data-id="element-79" data-mp="1ebxvrvodzf0d">
          <FuelIcon className="h-4 w-4" aria-hidden="true" data-id="element-80" data-mp="1o3v6707km2y1" /> {productShortName}
        </p>
        <h2 id="final-title" className="mx-auto mt-5 max-w-2xl text-balance text-3xl font-extrabold text-stone-50 sm:text-4xl" data-id="element-81" data-mp="1o67ojeh8qfbm">
          Hecho por especialistas, para docentes de Latinoamérica.
        </h2>

        <Countdown light className="mt-8" data-id="element-82" data-mp="n5m8m8upag51" />

        <div className="mt-8 flex flex-col gap-5 rounded-xl border-2 border-amber-500 bg-stone-50 p-6 text-left shadow-2xl shadow-black/30 sm:flex-row sm:items-center sm:justify-between" data-id="element-83" data-mp="n6w6oy1jzobo">
          <p data-id="element-84" data-mp="x2que7kmw9lb">
            <b className="block font-serif text-base leading-tight tracking-tight text-emerald-950" data-id="element-85" data-mp="x2z4xstab2tc">{productShortName}</b>
            <span className="text-sm text-stone-700" data-id="element-86" data-mp="120scap6bq2v7">
              {totalVolumes} tomos + {totalBonuses} bonos · Acceso inmediato
            </span>
          </p>
          <div className="shrink-0 sm:text-right" data-id="element-87" data-mp="1b2i621nohdw5">
            <p className="text-sm text-stone-700" data-id="element-88" data-mp="1b173u69vse75">
              <span className="mr-2 line-through" data-id="element-89" data-mp="1fvl0sd46ytdx">{priceBefore}</span>
              <b className="text-lg text-emerald-900" data-id="element-90" data-mp="1ktwa8mqkr1vm">{price}</b>
            </p>
            <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" size="sm" className="mt-2" data-id="element-91" data-mp="1psfywuwjyrro">
              Quiero mi Megapack ahora
            </Button>
          </div>
        </div>

        <ul className="mt-8 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-emerald-100" data-id="element-92" data-mp="3quow0r7donna">
          {assurances.map(item => <li key={item} className="inline-flex items-center gap-1.5" data-id="element-93" data-mp="3lwvu4ad3yfst">
              <CheckIcon className="h-4 w-4 text-amber-400" aria-hidden="true" data-id="element-94" data-mp="3hux4zgqwtkf" /> {item}
            </li>)}
        </ul>
      </div>
    </section>;
}